import { Box, Button, Link, useTheme } from "@material-ui/core";

import { InfoCircleOutlined } from "@eroad/icons/antd";
import { Cog } from "@eroad/icons/svg";
import { Tooltip } from "@eroad/ui-library/Tooltip";

import type { CoretexTheme } from "../../theme";
import { useStyles } from "./ResultsBar.styles";

type ResultsBarProps = {
  handleZoomAll: () => void;
  numResults: number;
  handleSettings?: () => void;
  settingsIconWidth?: number;
  settingsIconHeight?: number;
  maxZoomResults?: number;
  resultsText?: string;
  zoomAllText?: string;
  showTooltip?: boolean;
  tooltipText?: string;
};

const ResultsBar = ({
  handleZoomAll,
  handleSettings,
  settingsIconWidth,
  settingsIconHeight,
  numResults,
  maxZoomResults,
  resultsText,
  zoomAllText,
  showTooltip,
  tooltipText,
}: ResultsBarProps): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme<CoretexTheme>();
  const showZoomAll = numResults > 0 && numResults < (maxZoomResults ?? 3000);
  return (
    <Box data-testid="results-bar" className={classes.root}>
      <span data-testid="results-found" className={classes.resultsText}>
        {numResults} {resultsText ?? "vehicles found"}
      </span>
      {showTooltip && (
        <Tooltip title={tooltipText} placement="top">
          <InfoCircleOutlined data-testid="results-bar-infoIcon" className={classes.infoIcon} />
        </Tooltip>
      )}
      <span>
        {showZoomAll && (
          <Button
            data-testid="zoom-to-all"
            disableRipple
            className={classes.zoomAllText}
            component={Link}
            onClick={handleZoomAll}
          >
            {zoomAllText ?? "zoom to all"}
          </Button>
        )}
      </span>
      {!!handleSettings && (
        <Cog
          data-testid="list-settings"
          onClick={handleSettings}
          className={classes.settings}
          fill={theme.palette.mono.secondaryDark}
          height={settingsIconHeight ?? 16}
          width={settingsIconWidth ?? 16}
        />
      )}
    </Box>
  );
};

export { ResultsBar };
export type { ResultsBarProps };
